import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteBewertungsAnlassCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteBewertungsAnlassCommandService],
  exports: []
})
export class DeleteBewertungsAnlassCommandServiceModule { }
